import { render, staticRenderFns } from "./Prodes.vue?vue&type=template&id=2e71d8c8&lang=pug"
import script from "./Prodes.vue?vue&type=script&lang=js"
export * from "./Prodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports